import { render, staticRenderFns } from "./TableIndex.vue?vue&type=template&id=24c1ab36&scoped=true&"
import script from "./TableIndex.vue?vue&type=script&lang=js&"
export * from "./TableIndex.vue?vue&type=script&lang=js&"
import style0 from "./TableIndex.vue?vue&type=style&index=0&id=24c1ab36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c1ab36",
  null
  
)

export default component.exports